<template>
  <div class="cjwt-nr-item" >
    <div class="cjwt-nr-question">
      <span class="cjwt-wd-tit question"></span>
      <span class="cjwt-wd-body question">{{ wtda.question }}</span>
    </div>
    <div class="cjwt-nr-answer">
      <span class="cjwt-wd-tit answer"></span>
      <span class="cjwt-wd-body answer">{{ wtda.answer }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'wd',
  props: ['wtda'],
};
</script>
